<template>
    <div class="token-list-page">
        <div v-if="loading" style="text-align:center;">
            <mu-circular-progress :size="60" :strokeWidth="5"/>
        </div>
        <div v-else>
            <div v-if="TokenList.length">
                <div class="token-list">
                    <h3>我发行的Token</h3>
                    <div class="token-item-wrap" v-for="item in TokenList" :key="item.id"  @click="gotoDetail(item.address, item.blockchain_id)">
                        <TokenListItem :info="item"></TokenListItem>
                    </div>
                </div>
                <p class="total-token">共发行 {{TokenList.length}} 种Token</p>
            </div>
            <div v-else>
                <div class="empty-img">
                    <img src="../assets/empty.png" ><br>
                    <p>你还没有发行过Token<br>快去发行属于自己的Token吧</p>
                </div>
            </div>
            <mu-raised-button label="发行代币" @click="publishToken" fullWidth primary/>
        </div>

        <mu-dialog :open="dialog" title="温馨提示">
            通证大师暂不支持EOS币的管理，请到钱包首页添加管理
            <mu-flat-button label="确定" slot="actions" primary @click="close"/>
        </mu-dialog>

       
    </div>
</template>

<script>

import TokenListItem from './TokenListItem';
import u from 'underscore';
import $ from 'jquery';
import Web3 from 'web3';
import Axios from "axios";

const DOMAIN = 'https://preserver.mytokenpocket.vip';

export default {
  name: 'TokenList',
  data () {
    return {
        TokenList: [],
        loading: true,
        dialog: false,
        // ethWalletLoaded: false,
        // moacWalletLoaded: false,
        walletCount: 0
    }
  },
  created() {
        window.web3 = new Web3(new Web3.providers.HttpProvider("https://eth10xie2vce3mhh.jccdex.cn"));
        // window.web3 = new Web3(new Web3.providers.HttpProvider("https://ropsten.infura.io/oaJiGrlgSIEU1bkwyb8s"));
        window.chain3 = new Chain3(new Chain3.providers.HttpProvider('https://chain3.mytokenpocket.vip'));

        window.onGetWalletList = result => {
            this.walletCount++;
            let data = JSON.parse(result)
            // alert('拿到钱包信息');
            if (data.wallets && data.wallets.eth) {
                // this.ethWalletLoaded = true;
                // console.log('拿到eth钱包信息');
                u.each(data.wallets.eth, wallet => {
                    let addr = wallet.address;
                    Axios.get(DOMAIN + '/v1/token/list_by_owner?start=0&count=10&address=' + addr).then(res => {
                        let result = res.data;
                      
                        if (result.result === 0 && result.data && result.data.length) {
                            u.each(result.data, item => {
                                if (item.blockchain_id === 1) {
                                    this.TokenList.push(item);
                                    this.loading = false;
                                }
                            });
                        }
                        return res;
                    })

                    // 未完成的hash
                    Axios.get(DOMAIN + '/v1/publish_token/list?blockchain_id=1&address=' + addr).then(res => {
                        let result = res.data;

                        if (result.result === 0 && result.data && result.data.length) {

                            u.each(result.data, item => {
                                let hash = item.hash;

                                web3.eth.getTransactionReceipt(hash, (err2, data) => {

                                    if (!err2) {
                                        if (data.logs && data.logs[0]) {
                                            let contractAddress = data.logs[0].address;

                                            $.post(DOMAIN + '/v1/token/contract', {
                                                address: contractAddress,
                                                source: 'tokenmaster',
                                                owner_address: addr
                                            }).then(data1 => {
                                                // 上币成功
                                                if (data1.result === 0) {
                                                    var tokenId = data1.data;
                                                    var walletId = wallet.wallet_id;

                                                    $.post(DOMAIN + '/v1/wallet/token', {
                                                        token_id: tokenId,
                                                        wallet_id: walletId
                                                    });

                                                    $.post(DOMAIN + '/v1/publish_token/delete', {
                                                        hash: hash
                                                    });
                                                }
                                            });
                                        }
                                    }
                                });
                            })
                        }
                    })
                });

                
            }
            else if (data.wallets && data.wallets.moac) {
                // this.moacWalletLoaded = true;
                // console.log('拿到moac钱包信息');
                
                u.each(data.wallets.moac, wallet => {
                    let addr = wallet.address;
                    Axios.get(DOMAIN + '/v1/token/list_by_owner?start=0&count=10&address=' + addr).then(res => {
                        let result = res.data;
                        if (result.result === 0 && result.data && result.data.length) {
                            u.each(result.data, item => {
                                if (item.blockchain_id === 3) {
                                    var totalSupplyBn = web3.utils.toBN(item.total_supply);
                                    var decimalBn = web3.utils.toBN(Math.pow(10, +item.decimal));
                                    item.amount = totalSupplyBn.div(decimalBn).toString();
                                    this.TokenList.push(item);
                                    this.loading = false;
                                }
                            });
                        }
                        return res;
                    })

                    // 未完成的hash
                    Axios.get(DOMAIN + '/v1/publish_token/list?blockchain_id=3&address=' + addr).then(res => {
                        let result = res.data;

                        if (result.result === 0 && result.data && result.data.length) {

                            u.each(result.data, item => {
                                let hash = item.hash;

                                chain3.mc.getTransactionReceipt(hash, (err2, data) => {

                                    if (!err2) {
                                        if (data.logs && data.logs[0]) {
                                            let contractAddress = data.logs[0].address;

                                            $.post(DOMAIN + '/v1/token/contract', {
                                                address: contractAddress,
                                                source: 'tokenmaster',
                                                owner_address: addr
                                            }).then(data1 => {
                                                // 上币成功
                                                if (data1.result === 0) {
                                                    var tokenId = data1.data;
                                                    var walletId = wallet.wallet_id;

                                                    $.post(DOMAIN + '/v1/wallet/token', {
                                                        token_id: tokenId,
                                                        wallet_id: walletId
                                                    });

                                                    $.post(DOMAIN + '/v1/publish_token/delete', {
                                                        hash: hash
                                                    });
                                                }
                                            });
                                        }
                                    }
                                });
                            })
                        }
                    })
                });
            }

            else if (data.wallets && data.wallets.eos) {
                u.each(data.wallets.eos, wallet => {
                    let addr = wallet.name;
                    Axios.get(DOMAIN + '/v1/token/list_by_owner?start=0&count=10&address=' + addr).then(res => {
                        let result = res.data;
                        if (result.result === 0 && result.data && result.data.length) {

                            u.each(result.data, item => {
                                item.amount = item.total_supply;
                                this.TokenList.push(item);
                                this.loading = false;
                            });
                        }
                        return res;
                    })
                });
            }

            // if (this.ethWalletLoaded && this.moacWalletLoaded) {
            //     this.loading = false;
            // }

            if (this.walletCount === 2) {
                this.loading = false;
            }
        }


        if (window.TPJSBrigeClient) {
            window.TPJSBrigeClient.callMessage("getWalletList", '{"type": 1}', "onGetWalletList");
            window.TPJSBrigeClient.callMessage("getWalletList", '{"type": 3}', "onGetWalletList");
            window.TPJSBrigeClient.callMessage("getWalletList", '{"type": 4}', "onGetWalletList");
        }
            // iOS
        else if (window.webkit) {
            window.webkit.messageHandlers.getWalletList.postMessage({body:{'params': '{"type": 1}', 'callback':'onGetWalletList'}});
            window.webkit.messageHandlers.getWalletList.postMessage({body:{'params': '{"type": 3}', 'callback':'onGetWalletList'}});
            window.webkit.messageHandlers.getWalletList.postMessage({body:{'params': '{"type": 4}', 'callback':'onGetWalletList'}});
        }
        else {
            alert('请在TokenPocket中打开！');
        }

        

  },
    components: {TokenListItem},
    methods: {
        publishToken() {
            this.$router.push('/token/publish');
        },
        gotoDetail(addr, blockchainId) {
            if (+blockchainId === 4) {
                this.dialog = true;
            }
            else {
                this.$router.push('/token/detail/' + addr);
            }
        },
        close () {
            this.dialog = false;
        }
  }
}
</script>

<style scoped lang="less">

.token-list {

    h3 {
        border-left: 2px solid #2096f3;
        padding-left: 10px;
        line-height: 1;
        margin: 10px 0;
    }
    .token-item-wrap {
        border-bottom: 1px solid #F1f1f1;
    }
}
.empty-img {
    text-align: center;
    margin-top: 40px;

    p {
        margin: 10px 0 30px;
    }
    

    img {
        width: 40%;
        max-width: 500px;
    }
}

    
.total-token {
    text-align: center;
    margin: 10px;
    color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/TokenList.vue